export default __webpack_public_path__ + "static/media/mountains.25ddb0c3.webp";